import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { SERVER_URL } from "../../../config/index";

const BASE_URL = SERVER_URL;

const initialState = {
  total: 0,
  RepairEstimatesServices: [],
  details: {},
};
export const RepairEstimatesServicesListingsReducer = createAsyncThunk(
  "RepairEstimatesServicesListingsReducer",
  async (obj, { getState }) => {
    const token = await localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${BASE_URL}/alliedService/getAllAlliedServiceRequest`,
        {
          params: {
            search: obj.search,
            page: obj.page,
            limit: obj.limit,
            service_id: obj.service_id,
          },
          headers: {
            token: token,
          },
        }
      );
      //console.log("slice data",response)
      // await localStorage.setItem("token", response?.data?.token)
      return response?.data;
    } catch (error) {
      return error?.message;
    }
  }
);

export const RepairEstimatesServicesDetailReducer = createAsyncThunk(
  "RepairEstimatesServicesDetailReducer",
  async (obj, { getState }) => {
    const token = await localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${BASE_URL}/alliedService/getAlliedServiceRequestDetails`,
        {
          params: {
            request_id: obj.id,
          },
          headers: {
            token: token,
          },
        }
      );
      //console.log("slice data",response)
      // await localStorage.setItem("token", response?.data?.token)
      return response?.data;
    } catch (error) {
      return error?.message;
    }
  }
);
export const RepairEstimatesServiceslistingSlice = createSlice({
  name: "RepairEstimatesServiceslistings",
  initialState,
  reducers: {
    reducerName: (state, action) => {},
  },
  extraReducers: {
    [RepairEstimatesServicesListingsReducer.fulfilled]: (state, action) => {
      // console.log(action)
      state.RepairEstimatesServices = action?.payload?.data?.items;
      state.total = action?.payload?.data?.total;
    },
    [RepairEstimatesServicesDetailReducer.fulfilled]: (state, action) => {
      //console.log(action)
      state.details = action?.payload?.data?.request;
    },
  },
});

export const { reducerName } = RepairEstimatesServiceslistingSlice.actions;

export default RepairEstimatesServiceslistingSlice.reducer;
